var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('p',{staticClass:"headline text--primary font-weight-bold"},[_vm._v("投票チェック")]),_vm._v(" チェックをしたい Twitter の ID を入力して「投票チェック」のボタンを押して下さい。 ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }